import TemplateHome from './TemplateHome'

export default TemplateHome
